import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
import { Debug } from '@awayjs/core';
var TextFormatDisplay = /** @class */ (function (_super) {
    __extends(TextFormatDisplay, _super);
    function TextFormatDisplay() {
        var _this = _super.call(this) || this;
        // @todo
        Debug.throwPIR('playerglobals/text/TextFormatDisplay', 'constructor', '');
        return _this;
    }
    TextFormatDisplay.classInitializer = null;
    TextFormatDisplay.classSymbols = null;
    TextFormatDisplay.instanceSymbols = null;
    TextFormatDisplay.INLINE = 'inline';
    TextFormatDisplay.BLOCK = 'block';
    return TextFormatDisplay;
}(ASObject));
export { TextFormatDisplay };
